import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { NewReleases } from '@material-ui/icons';

interface MigrationBannerProps {
    text: string,
    color: string
}

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    height: 70
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '20px'
  },
  text: {
    color: 'white',
    marginLeft: 10,
    marginRight: 10,
    fontWeight: 700,
    fontSize: '16px'
  }
}));

export const LEMigrationStatusBanner: React.FC<any> = (props: MigrationBannerProps) => {
  const styles = useStyles();

  return (
    <Grid container className={styles.container} style={{backgroundColor: props.color}}>
      <Grid item className={styles.content}>
        <NewReleases fontSize={'large'} style={{ color: 'white' }} />
        <span className={styles.text}>
          {props.text}
        </span>
      </Grid>
    </Grid>
  );
};
